(function ($) {
  $(document).ready(function () {
    if (
      $(".real-estate-form-container")
        .has(".gform_confirmation_wrapper")
        .children().length > 0
    ) {
      $(".real-estate-form-container .form-column .legal-text").hide();
      $(".real-estate-form-container .additional-info-container").hide();
    }
  });

  //
  // Video Testimonials: Show 3 items at a time
  //
  var items = $(".video-list-wrapper .item");
  var visible = 3; // Initial Display Count

  // Show the first 3 items
  items.slice(0, visible).removeClass("uk-hidden");

  // Show 3 more items when the button is clicked
  $(".load-more-testimonial-videos-btn").on("click", function () {
    visible += 3;
    items.slice(0, visible).removeClass("uk-hidden");

    if (visible >= items.length) {
      $(this).hide(); // Hide the Button when everything is displayed
    }
  });

  // Replace the video in the modal
  $( document ).on( 'click', '[uk-toggle][data-video-url]', function() {
			var videoUrl = $( this ).data( 'video-url' );
			var toggleAttr = $( this ).attr( 'uk-toggle' ) || $( this ).attr( 'data-uk-toggle' ) || '';
			var targetMatch = toggleAttr.match( /target:\s*([^;]+)/ );
			var modalSelector = targetMatch && targetMatch[1] ? $.trim( targetMatch[1] ) : $( this ).attr( 'href' );

			if ( videoUrl && modalSelector && modalSelector.charAt( 0 ) === '#' ) {
				$( modalSelector ).find( 'iframe' ).attr( 'src', videoUrl );
			}
	} );

		$( document ).on( 'hidden', '.video-modal', function() {
			$( this ).find( 'iframe' ).attr( 'src', '' );
		} );
})(jQuery);